import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import NavBar from '../components/NavBar';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';

function NotFoundContent() {
  const { language } = useLanguage();

  React.useEffect(() => {
    document.body.setAttribute('data-lang', language);
    document.documentElement.setAttribute('lang', language === 'bg' ? 'bg' : 'en');
  }, [language]);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{language === 'bg' ? 'Страницата не е намерена | Адвокат Петър Николов' : 'Page Not Found | Attorney Petar Nikolov'}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <NavBar />
      <section className="pt-32 pb-24 flex items-center justify-center min-h-[60vh]">
        <div className="text-center px-6">
          <h1 className="text-8xl font-serif font-bold text-navy mb-4">404</h1>
          <p className="text-2xl text-slate mb-8">
            {language === 'bg' ? 'Страницата не е намерена' : 'Page Not Found'}
          </p>
          <a href="/" className="btn-primary">
            {language === 'bg' ? 'Към началната страница' : 'Back to Homepage'}
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default NotFoundContent;
